import React from 'react';
import {Button, HStack, Text, View, VStack} from '@packages/systems/spring';
import {ComponentsCodeIcon} from '@packages/systems/spring-branded';
import {selectDesignerAbility} from '@packages/systems/designer-abilities';
import {useDesignerSelector} from '@packages/systems/designer/flux';
import {useFeatureFlag} from '@packages/systems/feature-config/client';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {useCodeComponentCreated} from './flux/CodeLibrariesSlice';

const canEditCodeComponentsSelector = selectDesignerAbility(
  'canEditCodeComponents'
);

export function CodeComponentEmbedNudge({
  onRequestClose,
}: {
  onRequestClose: () => Promise<boolean>;
}) {
  const canEditCodeComponents = useDesignerSelector(
    canEditCodeComponentsSelector
  );
  const areTemplatesEnabled = useFeatureFlag(
    FEATURE_FLAGS.AICC_COMPONENT_TEMPLATES
  );
  const createCodeComponent = useCodeComponentCreated();
  const [isPending, setIsPending] = React.useState(false);

  if (!canEditCodeComponents || !areTemplatesEnabled) return null;

  const handleCreate = async () => {
    setIsPending(true);
    try {
      if (await onRequestClose()) createCodeComponent();
    } finally {
      setIsPending(false);
    }
  };

  return (
    <View padding="$3" flexShrink={0}>
      <HStack
        padding="$2"
        backgroundColor="$backgroundSecondary"
        borderRadius="$2"
        data-automation-id="code-component-embed-nudge"
      >
        <View
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={43}
          height={43}
          flexShrink={0}
        >
          <ComponentsCodeIcon size="37px" />
        </View>
        <VStack spacing={1} flex={1} minWidth={0}>
          <Text weight="semibold">
            Want more interactivity? Create components with AI
          </Text>
          <Text colorVariant="secondary">
            Describe what you need and get a working component in your site’s
            style
          </Text>
        </VStack>
        <Button variant="outline" isDisabled={isPending} onClick={handleCreate}>
          Create component
        </Button>
      </HStack>
    </View>
  );
}
